// extracted by mini-css-extract-plugin
export var anchor = "contact-physiolymp-module--anchor--2IsxS";
export var imageContainer = "contact-physiolymp-module--image-container--OqJYq";
export var imageFrame = "contact-physiolymp-module--image-frame--HmmXD";
export var logo = "contact-physiolymp-module--logo--kT2Kl";
export var text = "contact-physiolymp-module--text--VO6IH";